export default __webpack_public_path__ + "static/media/logoa.e16743ec.png";